import React, { Component } from 'react';
import SelectPanZoomResize from '@/components/SelectPanZoomResize/SelectPanZoomResize.js';
import './App.css';
import { getStoreDecorator } from '@/store/withStore';


class App extends Component {
  render() {
   return <div className="App">
      <SelectPanZoomResize 
          animation = {true}
      />;
    </div>;
  }
}

export default getStoreDecorator()(App);
export { App as AppComponent };